import {updateControl} from '../../actions/control'

export function resetControl() {
	const nowDate = new Date()
	const newControlObject={
		controlled:nowDate,
		section:null,
		scanning:false,
		showGraph:false,
		revealAnswer:false,
		setPoll:null,
		setPollPoll:null,
		currentPoll:null,
		snapshot:null,
		mobileAccepted:false,
		paused:false,
		showCardAssignment:false
	}
	return updateControl(newControlObject)
}

